export const formatCurrency = (amount: number | string): string => {
  const num = typeof amount === 'string' ? parseFloat(amount) : amount;
  return num.toFixed(2);
};

export const roundAmount = (value: any): string => {
  const num = Number(value);
  if (isNaN(num)) {
    return "0.00";
  }
  const rounded = Math.round(num * 100) / 100;
  return rounded.toFixed(2);
};

export const formatTime = (time: { hours: string; minutes: string; seconds: string }): string => {
  return `${time.hours}:${time.minutes}:${time.seconds}`;
};

export const formatDate = (time: { year: string; month: string; day: string }): string => {
  return `${time.year}-${time.month}-${time.day}`;
};